import useLocationListenPrevLocation from './hooks/useLocationListenPrevLocation';
import useLocationInitOriginParams from './hooks/useLocationInitOriginParams';
import useLocationPlatformWatch from './hooks/useLocationPlatformWatch';
import { TLocationPlatform } from './location.t';
import useLocationSearchParamWatch from './hooks/useLocationSearchParamWatch';
import useLocationEventListener from "./hooks/useLocationEventListener";

interface ILocationProviderProps {
    platform?: TLocationPlatform;
}

function LocationProvider(props: ILocationProviderProps) {
    const { platform } = props;

    useLocationListenPrevLocation();
    useLocationInitOriginParams();
    useLocationPlatformWatch({ platform });
    useLocationSearchParamWatch();
    useLocationEventListener();

    return null;
}

export default LocationProvider;
